module.exports = __webpack_public_path__ + "static/media/basicFreediver-bg.4cd26d3d.jpg";